import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["city", "state", "zip", "country"];
  static values = {
    key: String
  };

  connect() {
    this.keyValue = this._initializeKey();
    document.addEventListener(
      "zipcode:loaded",
      this.handleZipcodeFound.bind(this)
    );
  }

  disconnect() {
    document.removeEventListener(
      "zipcode:loaded",
      this.handleZipcodeFound.bind(this)
    );
  }

  handleZipcodeFound(event) {
    const { clazz, clazz_id, city, state, country } = event.detail;
    if (!this._matchingKey(clazz, clazz_id)) return;

    if (country) {
      this.countryTarget.value = country;
      // trigger locale-switch controller
      this.countryTarget.dispatchEvent(new Event("change"));
    }
    if (city) this.cityTarget.value = city;
    if (state) this.stateTarget.value = state;
  }

  _initializeKey() {
    return this._generateKey(
      this.zipTarget.dataset.zipcodeLookupClazzValue,
      this.zipTarget.dataset.zipcodeLookupSourceValue
    );
  }

  _matchingKey(clazz, clazz_id) {
    return this.keyValue == this._generateKey(clazz, clazz_id);
  }

  _generateKey(clazz, clazz_id) {
    return `${clazz}:${clazz_id}`;
  }
}
